import { motion } from "framer-motion";
import { Zap, Mail, Timer } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { PRODUCT } from "../../config";
import useCountdown from "../../hooks/useCountdown";

export const FinalCTA = () => {
  const { h, m, s } = useCountdown();

  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-gradient-to-br from-blue-700 via-blue-600 to-cyan-500" id="cta-akhir">
      <div className="absolute inset-0 hero-grid-light pointer-events-none" />
      <div className="absolute -top-24 left-1/4 w-[400px] h-[400px] rounded-full bg-white/10 blur-[100px] pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur border border-white/25 px-4 py-2 text-white text-xs md:text-sm font-bold tracking-[0.14em] uppercase mb-7">
            <Timer className="w-4 h-4" /> Berakhir dalam {h}:{m}:{s}
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
            Jangan Lewatkan
            <br />
            Promo Bulan Ini
          </h2>

          <div className="mt-9 flex flex-col items-center gap-1">
            <span className="text-blue-100 text-xl md:text-2xl font-semibold line-through decoration-red-400 decoration-[3px]">
              {PRODUCT.priceNormalLabel}
            </span>
            <span className="font-heading text-6xl md:text-7xl font-extrabold text-white drop-shadow-[0_4px_30px_rgba(255,255,255,0.3)]" data-testid="final-promo-price">
              {PRODUCT.pricePromoLabel}
            </span>
          </div>

          <div className="mt-10">
            <CTAButton
              source="final-cta"
              size="xl"
              variant="secondary"
              testId="final-order-button"
              className="!text-blue-700 shadow-[0_20px_60px_rgba(0,0,0,0.25)]"
            />
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-blue-100 text-sm font-semibold">
            <span className="flex items-center gap-1.5">
              <Zap className="w-4 h-4" /> Aktivasi Otomatis
            </span>
            <span className="hidden sm:inline text-white/40">•</span>
            <span className="flex items-center gap-1.5">
              <Mail className="w-4 h-4" /> Pengiriman via Email & WhatsApp
            </span>
            <span className="hidden sm:inline text-white/40">•</span>
            <span className="flex items-center gap-1.5">
              <Timer className="w-4 h-4" /> Proses Cepat
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
